<form *ngIf="resource" [formGroup]="form" (ngSubmit)="save()" class="resource">
  <div class="jbm-modal-header">
    <jbm-crud-title subject="entity.resource" [action]="action"></jbm-crud-title>
    <div class="toolbar float-end">
      <jbm-activity-log-button *ngIf="id" subject_type="2" [subject_id]="id" subject="{{'entity.resource'|translate}}"
        [title]="resource.description">
      </jbm-activity-log-button>
      <jbm-help-button class="btn-light" [helpTopicID]="0"></jbm-help-button>
      <div class="toolbar-spacer-1"></div>
      <jbm-cross-close-button (onClick)="cancel()"></jbm-cross-close-button>
    </div>
  </div>
  <div class="jbm-modal-body">
    <jbm-text-input [formControl]="formControls.code" [submitted]="submitted" [id]="'code'" required="true"
      labelCaption="{{'entity.code'|translate}}" labelClass="width-8" class="input-20">
      <jbm-input-error [formControl]="formControls.code" [submitted]="submitted">
         <span *ngIf="formControls.code.hasError('code_not_unique')">{{'entity.code-not-unique'|translate}}</span>
         <span *ngIf="formControls.code.hasError('required')">{{'entity.requiredfield'|translate}}</span>
      </jbm-input-error>
    </jbm-text-input>
    <jbm-text-input [formControl]="formControls.description" [submitted]="submitted" [id]="'description'" required="true"
      labelCaption="{{'entity.description'|translate}}" labelClass="width-8" class="input-20">
      <jbm-input-error [formControl]="formControls.description" [submitted]="submitted">
         <span *ngIf="formControls.description.hasError('description_not_unique')">{{'entity.description-not-unique'|translate}}</span>
         <span *ngIf="formControls.description.hasError('required')">{{'entity.requiredfield'|translate}}</span>
      </jbm-input-error>
    </jbm-text-input>
   <jbm-select *ngIf="!id" [formControl]="formControls.type" [options]="typeOptions" [submitted]="submitted" [id]="'type'" required="true"
       [insertLeadingOption]="true" class="input-20" labelCaption="{{'entity.resource'|translate}} {{'entity.type'|translate|lowercase}}" 
       labelClass="width-8" class="input-20">
      <jbm-input-error [formControl]="formControls.type" [submitted]="submitted">
         {{'entity.requiredfield'|translate}}
      </jbm-input-error>
   </jbm-select>
    <jbm-check-group [formControl]="formControls.plantIds" [items]="plantItems" [submitted]="submitted" [id]="'plants'" required="true"
      labelCaption="{{'company.plants'|translate}}" labelClass="width-8" class="input-20 mt-3" (onItemsChange)="itemsChange($event)">
      <jbm-input-error [formControl]="formControls.plantIds" [submitted]="submitted">
        {{'entity.requiredfield'|translate}}
      </jbm-input-error>
    </jbm-check-group>
  </div>
  <div class="jbm-modal-footer">
    <div class="toolbar float-end">
      <jbm-save-button [subject]="'entity.resource'|translate" (click)="save()"></jbm-save-button>
      <div class="toolbar-spacer-1"></div>
      <jbm-cancel-button (click)="cancel()"></jbm-cancel-button>
    </div>
  </div>
</form>